import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import MaskInput from 'components/MaskedInput';

import { useValidationUtils } from '../utils/validationUtils';

interface NpkInputSectionProps {
  inputN: string;
  setInputN: (value: string) => void;
  cleaninputn: string;
  inputP: string;
  setInputP: (value: string) => void;
  cleaninputp: string;
  inputK: string;
  setInputK: (value: string) => void;
  cleaninputk: string;
  kgHa: string;
}

const NpkInputSection: FC<NpkInputSectionProps> = ({
  inputN,
  setInputN,
  cleaninputn,
  inputP,
  setInputP,
  cleaninputp,
  inputK,
  setInputK,
  cleaninputk,
  kgHa,
}) => {
  const { t } = useTranslation();
  const { errorsTop } = useValidationUtils();

  return (
    <div className="border-b border-primitiveGrey md:pb-0">
      <div className="text-black font-bold text-xl md:text-lg mb-8 break-inside-avoid">
        {t('fertilization')}
      </div>
      <div className="text-black font-bold md:text-lg mb-8 break-inside-avoid">
        {t('npkInput')} ({kgHa})
      </div>
      <div className="flex mx-[-0.5rem] mb-8">
        <div className="w-1/3 px-2 break-inside-avoid">
          <MaskInput
            titleClassName="top-[-9px] left-[8px]"
            title="N"
            className="w-full"
            value={inputN}
            onChange={setInputN}
            isBlueBg
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
            {errorsTop(cleaninputn) && <div> {errorsTop(cleaninputn)}</div>}
          </div>
        </div>
        <div className="w-1/3 px-2 break-inside-avoid">
          <MaskInput
            titleClassName="top-[-9px] left-[8px]"
            title={
              <div>
                P<sub>2</sub>O<sub>5</sub>
              </div>
            }
            className="w-full"
            value={inputP}
            onChange={setInputP}
            isBlueBg
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
            {errorsTop(cleaninputp) && <div> {errorsTop(cleaninputp)}</div>}
          </div>
        </div>
        <div className="w-1/3 px-2 break-inside-avoid">
          <MaskInput
            titleClassName="top-[-9px] left-[8px]"
            title={
              <div>
                K<sub>2</sub>O
              </div>
            }
            className="w-full"
            value={inputK}
            onChange={setInputK}
            isBlueBg
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
            {errorsTop(cleaninputk) && <div> {errorsTop(cleaninputk)}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NpkInputSection;
